import { ReactElement } from 'react';
import { useFormikContext } from 'formik';
import { NEW_NON_EMPLOYEE_KEYS } from 'pages/NewNonEmployee/_const';

/**
 * If the user is a site admin, as indicated by their roles, do not display the wrapped children components
 * @returns {ReactElement} form inputs for site administrator and sponsor questions
 */
const SiteAdminRoleCheck = props => {
	const { values } = useFormikContext();
	const hasRole = values[NEW_NON_EMPLOYEE_KEYS.REQUESTOR_IS_SITE_ADMIN];

	return hasRole ? null : props.children;
};
export default SiteAdminRoleCheck;
